import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { AgeGenderStorageFactor, AgeGenderStorageFactorValue } from 'src/app/models/AgeGenderStorageFactor.model';
import { AgeGender } from 'src/app/models/AgeGender.model';
import { StorageSpaceSingle } from 'src/app/models/StorageSpaces.model';
import { CloneService } from 'src/app/services/clone.service';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';

@Component({
  selector: 'app-age-gender-storage-factor',
  templateUrl: './age-gender-storage-factor.component.html',
  styleUrls: ['./age-gender-storage-factor.component.scss']
})
export class AgeGenderStorageFactorComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,private cloneService:CloneService) { }


  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('ageGenderStorageFactor', this._formBuilder.array([]));
    this.form.setControl('ageGenderStorageFactor', this.asFormGroup(this.data));
    this.lascCtrl = this.form.get('ageGenderStorageFactor');
    this.lascCtrl= this.lascCtrl.get('values');
    this.data.values =  this.lascCtrl.value as AgeGenderStorageFactorValue[];
    this.gridData=this.ConvertData();
  }
  
  @Input('form') parentForm: FormGroup;
  @Input('data') data: AgeGenderStorageFactor;
  @Input('colHeaders') colHeaders: AgeGender[];
  @Input('rowHeaders') rowHeaders: StorageSpaceSingle[];
  @Input('isEditable') isEditable: boolean;

  gridData: GridData=new GridData();
  form: FormGroup;
  lascCtrl;

  asFormGroup(o: AgeGenderStorageFactor): FormGroup {
    const fg = new FormGroup({
      id: new FormControl(o.id, Validators.required),
      values: new FormControl(o.values, Validators.required)
    });
    return fg;
  }

  ConvertData(): GridData {
    for (let i = 0; i < this.data.values.length; i++) {
      const element = this.data.values[i];
      element.ageGenderId+=1;
      element.storageSpaceId+=1;
    }
    // for (let i = 0; i < this.data.values.length; i++)
    // {
    //   this.data.values[i].value=Math.round(this.data.values[i].value *100);
    // }
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id + 1,headerEntry.name));
    }

    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id + 1,headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = this.data.values;
    grid.colProp = 'ageGenderId';
    grid.rowProp = 'storageSpaceId';
    grid.switchColWithRow = false;
    return grid;
  }
  normalizeAgeGenderAndLuggageTypeIds(temp: AgeGenderStorageFactorValue[]) {
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      element.storageSpaceId-=1;
      element.ageGenderId-=1;
      element.value=element.value;
      // element.value=element.value/100;
    }
    this.data.values=temp;
  }
  save()
  {
    let clonedGridData = this.cloneService.deepClone(this.gridData.matrix) as AgeGenderStorageFactorValue[];
    this.normalizeAgeGenderAndLuggageTypeIds(clonedGridData);
    if(this.lascCtrl !== null)
    {
      this.lascCtrl.patchValue(this.data.values);
    }
  }
}
